<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-end text-secondary" *ngIf="isModificationMode">Contact du {{ interview.interviewDate | date }}</h3>
    <div class="text-end text-secondary pb-2" *ngIf="isModificationMode">
      {{ Title[beneficiary?.title] }} {{ beneficiary.firstName }} {{ beneficiary.usualName }}
    </div>
    <h3 class="text-end text-secondary pb-2" *ngIf="!isModificationMode">Création d'un contact</h3>
  </div>
  <form *ngIf="interviewDetailsForm" [formGroup]="interviewDetailsForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="row">
        <div class="mb-3 text-secondary col-12">
          <small class="form-text text-secondary">Les champs marqués d'un * sont obligatoires. </small>
        </div>

        <div class="mb-3 text-secondary col-12 col-md-6">
          <label class="required">Date</label>
          <app-datepicker
            id="fieldInterviewDate"
            formControlName="interviewDate"
            [invalid]="submitted && interviewDetailsForm.controls?.interviewDate?.invalid"
          ></app-datepicker>
          <small *ngIf="submitted && interviewDetailsForm.controls?.interviewDate?.errors?.dateFormat" class="form-text text-danger">
            La date du contact est invalide.
          </small>
          <small *ngIf="submitted && interviewDetailsForm.controls?.interviewDate?.errors?.required" class="form-text text-danger">
            La date du contact est requise.
          </small>
        </div>

        <!-- spacing col -->
        <div class="mb-3 col-0 col-md-6"></div>

        <div class="mb-3 text-secondary col-6" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <label class="required">De</label>
          <select
            id="beginTimeInterview"
            class="form-select"
            formControlName="beginTimeInterview"
            (change)="setEndTimeValue()"
            [class.is-invalid]="submitted && interviewDetailsForm.controls?.beginTimeInterview?.errors?.required"
          >
            <option *ngIf="!interviewDetailsForm.value.beginTimeInterview" [ngValue]="" selected hidden></option>
            <option *ngFor="let beginTimeInterview of beginTimes" [ngValue]="beginTimeInterview">
              {{ beginTimeInterview | printTime }}
            </option>
          </select>
          <small *ngIf="interviewDetailsForm.errors?.timesOrder" class="form-text text-danger">
            L'heure de début est incohérente avec l'heure de fin.
          </small>
          <small *ngIf="submitted && interviewDetailsForm.controls?.beginTimeInterview?.errors?.required" class="form-text text-danger">
            L'heure de début est requise.
          </small>
        </div>

        <div class="mb-3 text-secondary col-6" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <label>A</label>
          <select id="endTimeInterview" class="form-select" formControlName="endTimeInterview">
            <option *ngIf="!interviewDetailsForm.value.endTimeInterview" [ngValue]="" selected hidden></option>
            <option *ngFor="let endTimeInterview of endTimes" [ngValue]="endTimeInterview">
              {{ endTimeInterview | printTime }}
            </option>
          </select>
          <small *ngIf="interviewDetailsForm.errors?.timesOrder" class="form-text text-danger"
            >L'heure de fin est incohérente avec l'heure de début.</small
          >
        </div>

        <ng-container *appOnlyGroups="['RECEPTION']">
          <div class="mb-3 col-12 col-md-6">
            <label class="text-secondary required">Point d'accueil</label>

            <ng-select
              formControlName="receptionSiteId"
              [items]="userAddresses"
              bindLabel="name"
              bindValue="siteAddressId"
              notFoundText=""
              [clearable]="false"
              [closeOnSelect]="true"
              [class.is-invalid]="submitted && interviewDetailsForm.controls?.receptionSiteId?.invalid"
            >
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <p class="mb-0">{{ item.name }}</p>
                <p class="mb-0">
                  {{ item.main + (item.complement ? ' - ' + item.complement : '') }}
                </p>
                <small class="text-muted">{{ item.city + ' - ' + item.postalCode }}</small>
              </ng-template>
            </ng-select>

            <small *ngIf="submitted && interviewDetailsForm.controls?.receptionSiteId?.errors?.required" class="form-text text-danger">
              Le point d'accueil est requis.
            </small>
          </div>
          <div class="mb-3 col-0 col-md-6"></div>
        </ng-container>

        <div class="mb-3 text-secondary col-12 col-md-6" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <label class="required">Réalisé par</label>
          <select class="form-select" formControlName="directedBy">
            <option *ngIf="!interviewDetailsForm.value.directedBy" [ngValue]="" selected hidden></option>
            <option *ngFor="let directedBy of userList" [ngValue]="directedBy.id">
              {{ directedBy.name }}
            </option>
          </select>
        </div>

        <div class="mb-3 text-secondary col-12 col-md-6" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <label class="required">Type</label>
          <select
            class="form-select"
            formControlName="interviewType"
            [class.is-invalid]="submitted && interviewDetailsForm.controls?.interviewType?.errors?.required"
          >
            <option *ngIf="!interviewDetailsForm.value.interviewType" [ngValue]="" selected hidden></option>
            <option
              *ngFor="let interviewType of interviewsTypes | keyvalue: stringAscOrder"
              [ngValue]="interviewType.key"
              [hidden]="interviewType.key === 'Reception'"
            >
              {{ interviewType.value }}
            </option>
          </select>
          <small *ngIf="submitted && interviewDetailsForm.controls?.interviewType?.errors?.required" class="form-text text-danger">
            Le type est requis.
          </small>
        </div>

        <div class="mb-3 text-secondary col-12 col-md-6">
          <label [ngClass]="{ required: user.groups.includes('RECEPTION') }">Thème principal</label>
          <select
            class="form-select"
            [class.is-invalid]="submitted && interviewDetailsForm.controls?.interviewTheme?.invalid"
            formControlName="interviewTheme"
          >
            <option [ngValue]="" selected></option>
            <option *ngFor="let interviewTheme of interviewThemes" [ngValue]="interviewTheme.id">
              {{ interviewTheme.label }}
            </option>
          </select>
          <small *ngIf="submitted && interviewDetailsForm.controls?.interviewTheme?.errors?.required" class="form-text text-danger">
            Le thème est requis.
          </small>
        </div>

        <div class="mb-3 text-secondary col-12 col-md-6" *appOnlyGroups="['RECEPTION']">
          <label [ngClass]="{ required: user.groups.includes('RECEPTION') }">Réponse apportée</label>
          <div for="bring-answer" class="mb-3 text-secondary">
            <ng-select
              id="bring-answer"
              formControlName="answerProvidedIds"
              [items]="answersProvided"
              bindValue="id"
              bindLabel="label"
              [multiple]="true"
              [closeOnSelect]="false"
              groupBy="category"
              [selectableGroup]="true"
              [selectableGroupAsModel]="false"
              [class.is-invalid]="submitted && interviewDetailsForm.controls?.answerProvidedIds?.invalid"
            ></ng-select>
            <small *ngIf="submitted && interviewDetailsForm.controls?.answerProvidedIds?.errors?.required" class="form-text text-danger">
              Le champ est requis.
            </small>
          </div>
        </div>

        <div class="mb-3 text-secondary col-12 col-md-6" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <label>Présence</label>
          <select class="form-select" formControlName="presence">
            <option *ngIf="!interviewDetailsForm.value.presence" [ngValue]="null" selected></option>
            <option *ngFor="let presence of presences | keyvalue: stringAscOrder" [ngValue]="presence.key">
              {{ presence.value }}
            </option>
          </select>
        </div>

        <div class="mb-3 col-12" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <label class="text-secondary required">Adresse</label>

          <ng-select
            formControlName="address"
            [items]="userAddresses"
            bindLabel="main"
            bindValue="id"
            notFoundText=""
            [clearable]="false"
            [closeOnSelect]="true"
            [class.is-invalid]="submitted && interviewDetailsForm.controls.address.invalid"
          >
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <p class="mb-0">
                {{ item.main + (item.complement ? ' - ' + item.complement : '') }}
              </p>
              <small class="text-muted">{{ item.city + ' - ' + item.postalCode }}</small>
              <p>
                <small class="text-muted">{{
                  item.position && item.telephone ? item.position + ' - ' + item.telephone : item.telephone || item.position
                }}</small>
              </p>
            </ng-template>
          </ng-select>

          <small *ngIf="submitted && interviewDetailsForm.controls?.address?.errors?.required" class="form-text text-danger">
            L'adresse est requise.
          </small>
        </div>

        <div class="mb-3 text-secondary col-12" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <label>Synthèse</label>
          <textarea class="form-control" formControlName="synthesis" rows="8"></textarea>
        </div>

        <div class="mb-3 text-secondary col-12" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <label>Notes pour le prochain contact</label>
          <textarea class="form-control" formControlName="note" rows="3"></textarea>
        </div>
      </div>
    </div>

    <!-- Boutons actions -->
    <div class="row px-3">
      <div class="col-3 d-md-none d-lg-block col-lg-3 mb-1" *ngIf="isModificationMode && user.groups.includes('RECEPTION')"></div>
      <div class="col-6 d-md-none d-lg-block col-lg-6 mb-1" *ngIf="!isModificationMode"></div>
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1" *ngIf="isModificationMode">
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          (click)="deleteInterview()"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'RECEPTION']"
        >
          <fa-icon icon="trash"></fa-icon>
          <span class="ms-3 d-none d-md-block">Supprimer</span>
        </button>
      </div>
      <ng-container *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY']">
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1" *ngIf="isModificationMode">
          <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary" id="dropdownPrint" type="button" ngbDropdownToggle>
              <fa-icon icon="print"></fa-icon>
              <span class="mx-3">Imprimer</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownPrint">
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('Init')">
                Convocation initiale RSA
              </button>
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('Support')">
                Convocation accompagnement RSA
              </button>
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('FollowAbsence')">
                Convocation suite absence RSA
              </button>
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('JustifiedAbsenceRSA')">
                Convocation RSA suite absence justifiée
              </button>
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('BeforeReport')">
                Convocation avant signalement RSA
              </button>
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('IER')">
                Convocation accompagnement
              </button>
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('FirstAbsenceIER')">
                Convocation suite absence
              </button>
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('SecondAbsenceIER')">
                Convocation 2ème relance
              </button>
              <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="downloadDocument('RSJ')">
                Convocation renouvellement RSJ
              </button>
            </div>
          </div>
        </div></ng-container
      >

      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-3 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="submit"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'RECEPTION']"
          [disabled]="!hasStructure"
        >
          <fa-icon icon="save"></fa-icon>
          <span class="ms-3 d-none d-md-block">Sauvegarder</span>
        </button>
      </div>
    </div>
  </form>
</div>
